module.exports = __webpack_public_path__ + "static/media/26 - Saint DX - Prime of Your Life.748a2cd5.mp3";